module.exports = require("./zgh-MA");